import { useT } from "../../i18n/LanguageContext";

export default function Process() {
    const { t } = useT();
    const steps = t("process.steps");

    return (
        <section
            id="process"
            data-testid="process-section"
            className="py-24 md:py-32 lg:py-40"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 md:mb-20">
                    <div className="lg:col-span-5 reveal">
                        <p className="overline mb-6">{t("process.overline")}</p>
                        <h2 className="font-serif text-4xl sm:text-5xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.05] text-ink">
                            {t("process.headlineA")}{" "}
                            <em className="italic font-light text-terracotta">
                                {t("process.headlineEm")}
                            </em>{" "}
                            {t("process.headlineB")}
                        </h2>
                    </div>
                    <div className="lg:col-span-6 lg:col-start-7 lg:pt-4 reveal">
                        <p className="text-base md:text-lg leading-relaxed text-secondary">
                            {t("process.intro")}
                        </p>
                    </div>
                </div>

                <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--border-warm)] border border-warm">
                    {steps.map((s, i) => (
                        <li
                            key={s.n}
                            data-testid={`process-step-${i}`}
                            className="reveal bg-[var(--sand)] p-7 md:p-9 lg:p-10 flex flex-col h-full"
                        >
                            <div className="flex items-baseline justify-between mb-8">
                                <span className="font-serif text-terracotta text-3xl italic">
                                    {s.n}
                                </span>
                                <span className="overline text-secondary">
                                    {t("process.stepLabel")}
                                </span>
                            </div>
                            <h3 className="font-serif text-2xl md:text-3xl tracking-tight text-ink leading-tight">
                                {s.title}
                            </h3>
                            <p className="mt-4 text-base leading-relaxed text-secondary">
                                {s.body}
                            </p>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
}
